import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MagnifierPlusIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        data-testid="icon-magnifierPlus"
        fill={customColour}
        className={styles[className]}
        fillRule="evenodd"
      >
        <path d="M7.21896078,5.07210984e-07 C4.09057359,-0.00116721751 1.31777717,2.01405949 0.352543403,4.99040984 C-0.612690363,7.96676019 0.449531183,11.2261833 2.98297687,13.0618858 C5.51642256,14.8975882 8.94394088,14.8913734 11.4707155,13.0464957 L14.4347326,16.0000005 L16,14.4344206 L13.035983,11.4698129 C14.6359676,9.27544555 14.8688277,6.36846354 13.6385648,3.94729246 C12.4083019,1.52612137 9.92323799,0.000740979235 7.2078596,5.07210984e-07 L7.21896078,5.07210984e-07 Z M11.5452205,4.71894587 C12.4375867,6.2648776 12.4375867,8.16954405 11.5452205,9.71547578 C10.6528542,11.2614075 9.00369332,12.2137407 7.21896078,12.2137407 C4.46000339,12.2137407 2.22342654,9.97671805 2.22342654,7.21721083 C2.22342654,4.45770361 4.46000339,2.22068096 7.21896078,2.22068096 C9.00369332,2.22068096 10.6528542,3.17301414 11.5452205,4.71894587 Z" />
        <path d="M8,5 L8,7 L10,7 L10,8 L8,8 L8,10 L7,10 L7,8 L5,8 L5,7 L7,7 L7,5 L8,5 Z" />
      </g>
    </Icon>
  )
}
